import { createSlice } from "@reduxjs/toolkit";
import { decodeToken } from "../../utils/jwtDecode";

const getUserFromToken = (token) => {
  if (!token) return null;
  const decoded = decodeToken(token);
  if (!decoded) return null;

  return {
    id: decoded.user_id,
    name: decoded.name,
    email: decoded.email,
    type: decoded.type,
    mobile_number: decoded.mobile_number,
    is_active: decoded.is_active,
    email_verified: decoded.email_verified,
    mobile_verified: decoded.mobile_verified,
    profile_pic: decoded.profile_pic || null,
  };
};

const token = localStorage.getItem("access_token");
const initialState = {
  user: getUserFromToken(token),
  token: token || null,
  refreshToken: localStorage.getItem("refresh_token") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { access_token, refresh_token } = action.payload;

      const userData = getUserFromToken(access_token);

      state.user = userData;
      state.token = access_token;
      state.refreshToken = refresh_token;

      if (access_token) {
        localStorage.setItem("access_token", access_token);
      }
      if (refresh_token) {
        localStorage.setItem("refresh_token", refresh_token);
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
  },
});

export const { setCredentials, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;
